import { render } from "./Intro.vue?vue&type=template&id=e05a4706"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"
script.render = render

export default script